<div class="role-users-container">
  <div class="px-6 py-4">
    <div class="flex justify-content-between align-items-center mb-4">
      <p class="text-xl font-semibold m-0">{{ 'layout.configurations.users.assignRolesToUser.title' | translate }}</p>
      <div *emPermission="Permission.CONFIG_USER_MANAGEMENT" class="flex gap-2">
        <p-button type="button" icon="pi pi-send" severity="info" [rounded]="false"
          [pTooltip]="'layout.configurations.users.sendToNewUsersTooltip' | translate"
          [label]="'layout.configurations.users.sendToNewUsers' | translate"
          tooltipPosition="bottom" (click)="shareCredentialsToNewUsers()">
        </p-button>
        <p-button type="button" icon="pi pi-plus" severity="success" [rounded]="false"
          [pTooltip]="(isEditing() ? 'layout.configurations.users.updateRoles' : 'layout.configurations.users.assignRolesToUser.assignRoles') | translate"
          tooltipPosition="bottom" (click)="assignRoles()">
        </p-button>
        <p-button *ngIf="isEditing()" type="button" icon="pi pi-times" severity="secondary" [rounded]="false"
          [pTooltip]="'layout.configurations.users.cancelEdit' | translate" tooltipPosition="bottom" (click)="cancelEdit()">
        </p-button>
      </div>
    </div>



    <!-- Individual Role Assignments Table -->
    <div class="bg-white">
      <p-toolbar styleClass="mb-4 w-full gap-2 payroll-toolbar">
        <div class="w-full flex justify-content-end gap-2">
          <button pButton pRipple class="p-button-outlined p-button-sm btn-clear"
            icon="pi pi-filter-slash btn-icon-spacing" [label]="'common.filters.clear' | translate"
            (click)="clearAllFilters()">
          </button>

          <button pButton pRipple class="p-button p-button-sm btn-filter" icon="pi pi-filter btn-icon-spacing"
            [label]="'common.filters.show' | translate" (click)="toggleFilters()">
          </button>
        </div>
      </p-toolbar>
      <p-table [value]="filteredUserRoles" [loading]="loading" [globalFilterFields]="['firstName', 'lastName']" dataKey="id"
        [scrollable]="true" scrollHeight="600px" [paginator]="true" [rows]="10" [rowsPerPageOptions]="[10,20, 50, 100]"
        paginatorPosition="bottom" paginatorAlignment="center" [totalRecords]="totalRecords"
        [tableStyle]="{ 'min-width': '60rem' }" styleClass="mt-2 p-datatable-sm p-datatable-gridlines">

        <ng-template pTemplate="header">
          <tr>
            <th style="width: 4rem"></th>
            <th pSortableColumn="firstName">
              {{ 'layout.configurations.users.user' | translate }}
              <p-sortIcon field="firstName"></p-sortIcon>
            </th>
            <th>{{ 'layout.configurations.users.assignedRoles' | translate }}</th>
            <th>{{ 'layout.configurations.users.credentialsSent' | translate }}</th>
            <th *emPermission="Permission.CONFIG_USER_MANAGEMENT"> {{ 'layout.configurations.users.actions' | translate
              }}</th>
          </tr>
          <tr *ngIf="showFilterRow" class="filters" [formGroup]="filtersForm">
            <th></th>
            <th class="filters">
              <div class="filter-w flex align-items-center gap-1 w-full">
                <input pInputText class="p-inputtext w-full" formControlName="user" (ngModelChange)="applyFilters()"
                  [placeholder]="'common.filters.user' | translate" />
                <button pButton pRipple type="button" icon="pi pi-filter-slash btn-icon-spacing"
                  class="p-button-rounded p-button-text p-button-secondary p-button-sm"
                  *ngIf="filtersForm.get('user')?.value" (click)="filtersForm.get('user')?.reset(); applyFilters()"
                  [pTooltip]="'common.filters.clear' | translate" tooltipPosition="top">
                </button>
              </div>
            </th>
            <th class="filters">
              <div class="filter-w flex align-items-center gap-1 w-full">
                <p-multiSelect [options]="roles" formControlName="assignedRole" optionLabel="name" optionValue="name"
                  [showClear]="false" [placeholder]="'common.filters.assignedRole' | translate"
                  (onChange)="applyFilters()" styleClass="w-full" class="w-full" appendTo="body" [maxSelectedLabels]="1"
                  [selectedItemsLabel]="'layout.configurations.users.rolesSelected' | translate">
                </p-multiSelect>
                <button pButton pRipple type="button" icon="pi pi-filter-slash btn-icon-spacing"
                  class="p-button-rounded p-button-text p-button-secondary p-button-sm"
                  *ngIf="filtersForm.get('assignedRole')?.value?.length"
                  (click)="filtersForm.get('assignedRole')?.reset(); applyFilters()"
                  [pTooltip]="'common.filters.clear' | translate" tooltipPosition="top">
                </button>
              </div>
            </th>
            <th class="filters"></th>
            <th *emPermission="Permission.CONFIG_USER_MANAGEMENT"></th>
          </tr>
        </ng-template>

        <ng-template pTemplate="body" let-user let-expanded="expanded">
          <tr>
            <td>
              <p-button type="button" pRipple [pRowToggler]="user" [text]="true" [rounded]="true" [plain]="true"
                [icon]="expanded ? 'pi pi-chevron-down' : 'pi pi-chevron-right'">
              </p-button>
            </td>
            <td>
              <div class="flex align-items-center gap-2">
                <img [src]="user.profileImage || getPlaceholderImage(user)" [alt]="user.firstName + ' ' + user.lastName"
                  width="32" height="32" style="vertical-align: middle; border-radius: 50%"
                  (error)="onImageError($event, user)" />
                <span>{{ user.firstName }} {{ user.lastName }}</span>

                <!-- Archived Badge -->
                <p-tag *ngIf="user.archived" value="Archived" severity="warn" [rounded]="true"
                  [pTooltip]="'layout.configurations.users.assignRolesToUser.archiveUser.badgeTooltip' | translate"
                  tooltipPosition="top">
                </p-tag>

              </div>
            </td>
            <td>
              <div class="flex flex-wrap gap-1">
                <p-tag *ngFor="let assignment of getGroupedUserRoleAssignments()[user.id]"
                  [value]="assignment.role.name" [severity]="getRoleSeverity(assignment.role.name)">
                </p-tag>
              </div>
            </td>
            <td>
              <span *ngIf="isCurrentUser(user)" class="text-color-secondary font-bold pl-2">-</span>
              <ng-container *ngIf="!isCurrentUser(user)">
                <p-tag *ngIf="user.credentialsSent" [value]="'layout.configurations.users.sent' | translate" severity="success" [rounded]="true"></p-tag>
                <p-tag *ngIf="!user.credentialsSent" [value]="'layout.configurations.users.notSent' | translate" severity="secondary" [rounded]="true"></p-tag>
              </ng-container>
            </td>
            <td>
              <div *emPermission="Permission.CONFIG_USER_MANAGEMENT" class="flex gap-2 align-items-center">

                <!-- Edit Button (visible ONLY for ACTIVE users) -->
                <p-button *ngIf="!user.archived" icon="pi pi-pencil" [rounded]="true" [outlined]="true" severity="info"
                  size="small" [pTooltip]="'layout.configurations.users.assignRolesToUser.editRoles' | translate"
                  (onClick)="editUserRoles(user)">
                </p-button>

                <!-- Archive Button (visible for ACTIVE users only) -->
                <!--  <p-button *ngIf="!user.archived" icon="pi pi-trash" [rounded]="true" [outlined]="true" severity="danger"
                  size="small"
                  [pTooltip]="'layout.configurations.users.assignRolesToUser.archiveUser.tooltip' | translate"
                  (onClick)="archiveUser(user)">
                </p-button> -->

                <p-button *ngIf="!user.archived" icon="pi pi-trash" [rounded]="true" [outlined]="true" severity="danger"
                  size="small"
                  [pTooltip]="'layout.configurations.users.assignRolesToUser.deleteUserRole.tooltip' | translate"
                  (onClick)="deleteUserRoles(user)">
                </p-button>

                <!-- Share Credentials Button -->
                <p-button *ngIf="!user.archived && !isCurrentUser(user)" icon="pi pi-send" [rounded]="true" [outlined]="true" severity="warning"
                  size="small" [pTooltip]="'layout.configurations.users.shareCredentials' | translate"
                  (onClick)="shareCredentials(user)">
                </p-button>

                <!-- Reset Password Button (always visible) -->
                <p-button icon="pi pi-lock" [rounded]="true" [outlined]="true" severity="success" size="small"
                  [pTooltip]="user.archived ? ('layout.configurations.users.assignRolesToUser.resetPasswordArchived' | translate) : ('layout.configurations.users.assignRolesToUser.resetPassword' | translate)"
                  [disabled]="user.archived" (onClick)="toggleResetPasswordPanel($event, user)">
                </p-button>

                <p-overlayPanel #resetPasswordPanel>
                  <ng-template pTemplate="content">
                    <div class="flex flex-column justify-content-start w-10rem gap-1">
                      <p-button severity="danger" styleClass="w-full" (onClick)="resetMFA()">
                        {{ 'layout.configurations.users.assignRolesToUser.resetMFA' | translate }}
                      </p-button>
                      <p-button severity="danger" styleClass="w-full" (onClick)="resetUserPassword()">
                        {{ 'layout.configurations.users.assignRolesToUser.resetPassword' | translate }}
                      </p-button>
                    </div>
                  </ng-template>
                </p-overlayPanel>

              </div>
            </td>
          </tr>
        </ng-template>

        <ng-template pTemplate="rowexpansion" let-user>
          <tr>
            <td colspan="4">
              <div class="p-3">
                <h5>{{ 'layout.configurations.users.roleAssignmentsFor' | translate }} {{ user.firstName }} {{
                  user.lastName }}</h5>
                <p-table [value]="getGroupedUserRoleAssignments()[user.id]" dataKey="id">
                  <ng-template pTemplate="header">
          <tr>
            <th>{{ 'layout.configurations.users.role' | translate }}</th>
            <th>{{ 'layout.configurations.users.assignedDate' | translate }}</th>
            <th>{{ 'layout.configurations.users.assignedBy' | translate }}</th>
          </tr>
        </ng-template>
        <ng-template pTemplate="body" let-assignment>
          <tr>
            <td>
              <p-tag [value]="assignment.role.name" [severity]="getRoleSeverity(assignment.role.name)">
              </p-tag>
            </td>
            <td>{{ assignment.assignedDate | date: 'short' }}</td>
            <td>{{ assignment.assignedBy }}</td>

          </tr>
        </ng-template>
      </p-table>
    </div>
    </td>
    </tr>
    </ng-template>

    <ng-template pTemplate="emptymessage">
      <tr>
        <td colspan="4" class="text-center py-8">
          <div class="flex flex-col items-center gap-2">
            <i class="pi pi-users text-4xl text-gray-400"></i>
            <p class="text-gray-500">{{ 'layout.configurations.users.noUserRoleAssignmentsFound' | translate }}</p>
            <p class="text-sm text-gray-400">{{ 'layout.configurations.users.startAssigningRoles' | translate }}</p>
          </div>
        </td>
      </tr>
    </ng-template>
    </p-table>
  </div>

  <p-toast></p-toast>
  <p-confirmDialog [acceptLabel]="'layout.configurations.users.assignRolesToUser.yes' | translate"
    [rejectLabel]="'layout.configurations.users.assignRolesToUser.no' | translate"></p-confirmDialog>
</div>



<ng-template #noPermission>
  <div class="no-permission-message">
    <p class="text-center text-gray-500 py-8">
      <i class="pi pi-lock text-4xl mb-4 block"></i>
      {{ 'layout.configurations.users.noPermissionAccess' | translate }}
    </p>
  </div>
</ng-template>
